var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8662_21657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6727 13.2417C17.1426 14.4954 16.3134 15.6002 15.2576 16.4594C14.2019 17.3187 12.9517 17.9062 11.6164 18.1707C10.2812 18.4351 8.90142 18.3685 7.59785 17.9765C6.29429 17.5846 5.10659 16.8793 4.13858 15.9222C3.17058 14.9652 2.45174 13.7857 2.04493 12.4866C1.63811 11.1876 1.5557 9.80876 1.8049 8.47055C2.05409 7.13234 2.62731 5.87555 3.47444 4.81005C4.32156 3.74455 5.4168 2.90279 6.6644 2.35836M18.3311 9.99996C18.3311 8.90561 18.1156 7.82198 17.6968 6.81093C17.278 5.79988 16.6642 4.88122 15.8904 4.1074C15.1165 3.33358 14.1979 2.71975 13.1868 2.30096C12.1758 1.88217 11.0922 1.66663 9.9978 1.66663V9.99996H18.3311Z",
    stroke: "#EA580C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8662_21657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/PieChart.559a5a4ec32d30ac797394aef95b2392.svg";
export { ForwardRef as ReactComponent };